import { useEffect, useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import { Terms } from './Terms';
import { Privacy } from './Privacy';
import Tabs from 'react-bootstrap/Tabs';
import { LegalContentProvider, useLegalContent } from './LegalContentContext';

import './Legal.css';

interface LegalProps {
  pageKey?: 'terms' | 'privacy';
}

const LegalTabs = ({ pageKey }: LegalProps) => {
  const [activeKey, setActiveKey] = useState<string>(pageKey ?? 'terms');
  const { setSelectedTenancyKey } = useLegalContent();

  useEffect(() => {
    if (pageKey) {
      setActiveKey(pageKey);
    }
  }, [pageKey]);

  return (
    <Tabs
      activeKey={activeKey}
      onSelect={(k) => {
        if (k) {
          setActiveKey(k);
          setSelectedTenancyKey(null);
        }
      }}
      id="controlled-legal-tab"
      className="mb-3"
    >
      <Tab eventKey="terms" title="Terms">
        <Terms />
      </Tab>
      <Tab eventKey="privacy" title="Privacy">
        <Privacy />
      </Tab>
    </Tabs>
  );
};

const Legal = (props: LegalProps) => {
  return (
    <LegalContentProvider>
      <LegalTabs {...props} />
    </LegalContentProvider>
  );
};

export { Legal };
